import React from 'react';
import { Container, Col, Row, ListGroup, Button, Modal, Badge } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { VoteStars } from "./voteStars";

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class TopMoviesPage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            movies: [],

            user: null,
            users: [],
            movieUserVotes: {},

            showMovieDetails: null,

            movieUserReviewsMovieId: null,
            movieUserReviews: null,

            showReviewModal: false,
            reviewModalMovie: null,
            reviewModalVote: 0,
            reviewModalBrief: "",
            reviewModalReview: "",
            
            showErrorModal: false,
            errorModalText: ""
        };
        
        this.refreshData();
    }

    async refreshData() {
        const u = await IntrashBackend.getLoggedInUser();
        const allUsers = await IntrashBackend.getUsers();
        const allMovies = await IntrashBackend.getMovies();
        const allVotes = await IntrashBackend.getMovieUserVotes();
        var movieReviews = null;
        if (this.state.movieUserReviewsMovieId !== null) { movieReviews = await IntrashBackend.getMovieUserReviews(this.state.movieUserReviewsMovieId); }
        const filteredMovies = this.props.moviesFilter(allMovies, allVotes);
        this.setState({ movies: filteredMovies, user: u, users: allUsers, movieUserVotes: allVotes, movieUserReviews: movieReviews });
    }

    componentDidUpdate(prevProps) {
        if (this.props.moviesFilter !== prevProps.moviesFilter) {
            this.refreshData();
        }
    }

    async toggleMovieDetails(e, movieId) {
        // Check if the movie details are already being shown
        if (this.state.showMovieDetails !== null && this.state.showMovieDetails === movieId) {
            // Hide the details
            this.setState({ showMovieDetails: null });
        }
        else {
            // Fetch the movie reviews (if necessary)
            var reviews = this.state.movieUserReviews;
            if (reviews === null || this.state.movieUserReviewsMovieId !== movieId) {
                reviews = await IntrashBackend.getMovieUserReviews(movieId);
            }
            
            // Show the details
            this.setState({ showMovieDetails: movieId, movieUserReviewsMovieId: movieId, movieUserReviews: reviews });
        }
        e.preventDefault();
    }

    movieAverageVote(movieId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        var voteCount = 0;
        var totalVote = 0.0;
        Object.values(this.state.movieUserVotes[movieId]).forEach(v => { totalVote += v; ++voteCount; });
        return voteCount > 0 ? (totalVote / voteCount) : null;
    }

    movieAverageVoteString(movieId) {
        const averageVote = this.movieAverageVote(movieId);
        return averageVote === null ? "-" : (averageVote / 20.0).toFixed(2);
    }

    movieUserVote(movieId, userId) {
        if (this.state.movieUserVotes[movieId] === undefined) return null;
        if (this.state.movieUserVotes[movieId][userId] === undefined) return null;
        return this.state.movieUserVotes[movieId][userId];
    }

    movieUserVoteString(movieId, userId) {
        const vote = this.movieUserVote(movieId, userId);
        return vote === null ? "-" : (vote / 20.0);
    }

    async showReview(movie, userId) {
        const vote = this.movieUserVote(movie.id, userId);
        if (vote === undefined || vote === null) return;
        const movieReview = await IntrashBackend.getMovieUserReviews(movie.id, userId);
        if (movieReview === undefined || movieReview === null) return;
        const brief = movieReview === null ? "" : movieReview.brief;
        const review = movieReview === null ? "" : movieReview.review;
        this.setState({
            showReviewModal: true,
            reviewModalMovie: movie,
            reviewModalVote: vote,
            reviewModalBrief: brief,
            reviewModalReview: review
        });
    }

    mapMovieToListItem = (movie) => {
        const renderWatchedEye = () => {
            if (movie.watched) {
                return (<FaEye size="1.5em" color="gray"/>);
            }
            else {
                return (<FaEyeSlash size="1.5em" color="gray"/>);
            }
        }
        const mapUserDetailsToMovieDetails = (userDetails) => {
            const u = userDetails.user;
            const hasReview = userDetails.brief !== null && userDetails.brief.trim() !== "";
            const reviewCursor = hasReview ? "pointer" : "default";
            return (
                <ListGroup.Item className="list-group-item border-0" style={{ padding: "0", overflow: "hidden" }} key={u.id} onClick={() => this.showReview(movie, u.id)}>
                    <Row className="align-items-center">
                        <Col xs="auto" style={{ paddingRight: 0, cursor: reviewCursor }}>
                            <VoteStars starSize="1em" vote={userDetails.vote} canEditVote={false}/>
                        </Col>
                        <Col xs="auto" style={{ paddingLeft: 0, paddingRight: 0, cursor: reviewCursor }}>
                            <Badge style={{ fontWeight: "bold", fontSize: "1em" }}>{u.username}</Badge>
                        </Col>
                        <Col style={{ paddingLeft: 0, cursor: reviewCursor }}>
                            <Badge style={{ fontWeight: "normal", fontStyle: "italic", fontSize: "1em" }}>{userDetails.brief}</Badge>
                        </Col>
                    </Row>
                </ListGroup.Item>
            );
        };
        const renderMovieDetails = () => {
            if (this.state.showMovieDetails === movie.id) {
                var userDetails = [];
                const userVotes = this.state.movieUserVotes[movie.id];
                const userReviews = this.state.movieUserReviews;
                this.state.users.forEach(u => {
                    const uVote = userVotes[u.id];
                    const uReview = userReviews[u.id];
                    if ((uVote !== undefined) || (uReview !== undefined)) {
                        userDetails.push({
                            user: u,
                            vote: uVote || 0,
                            brief: uReview === undefined ? "" : uReview.brief,
                            review: uReview === undefined ? "" : uReview.review
                        });
                    }
                });
                userDetails.sort((a, b) => b.user.username.toUpperCase() < a.user.username.toUpperCase() ? 1 : -1);
                return (
                    <ListGroup variant="flush" style={{ paddingTop: "1em" }}>
                        {Object.values(userDetails).map(mapUserDetailsToMovieDetails)}
                    </ListGroup>
                );
            }
        };

        const averageVote = this.movieAverageVote(movie.id);

        return (
            <ListGroup.Item style={{ overflow: "hidden" }} key={movie.id}>
                <Row style={{alignItems: "center"}}>
                    <Col xs="auto" style={{ paddingRight: 0 }}>
                        {renderWatchedEye()}
                    </Col>
                    <Col>
                        <Container fluid>
                            <Row className="my-auto text-left" as="h4" style={{color: "darkslategray", cursor: "pointer"}} onClick={e => this.toggleMovieDetails(e, movie.id)}>{movie.title}</Row>
                            <Row className="my-auto text-left" as="h6" style={{color: "gray"}}>{movie.releaseYear}</Row>
                        </Container>
                    </Col>
                    <Col xs="auto">
                        <VoteStars starSize="1.75em" vote={averageVote || 0} canEditVote={false}/>
                    </Col>
                    <Col xs="auto" style={{ paddingLeft: 0, width: "4em" }}>
                        <Container fluid>
                            <Row className="my-auto justify-content-center" as="h4" style={{color: "darkslategray"}}>{this.movieAverageVoteString(movie.id)}</Row>
                            <Row className="my-auto justify-content-center" as="h6" style={{color: "gray"}}>{this.movieUserVoteString(movie.id, this.state.user.id)}</Row>
                        </Container>
                    </Col>
                </Row>
                {renderMovieDetails()}
            </ListGroup.Item>
        );
    }

    renderMoviesList() {
        return (
            <ListGroup>
                {this.state.movies.map(this.mapMovieToListItem)}
            </ListGroup>
        );
    }

    renderReviewModal() {
        return (
            <Modal show={this.state.showReviewModal} onHide={() => this.setState({ showReviewModal: false })}>
                <Modal.Header closeButton>
                    <Container>
                        <Row>
                            <VoteStars canEditVote={false} starSize="1.5em" vote={this.state.reviewModalVote}/>
                        </Row>
                        <Row>
                            <Modal.Title>{this.state.reviewModalBrief}</Modal.Title>
                        </Row>
                    </Container>
                </Modal.Header>
                <Modal.Body style={{ whiteSpace: "pre-line" }}>  
                    {this.state.reviewModalReview}               
                </Modal.Body>
            </Modal>
        );
    }

    render() {
        return (
            <>
                <Container fluid>
                    <Row><Col><h3 className="text-center">{this.props.title}</h3></Col></Row>
                    <br/>
                    {this.renderMoviesList()}
                </Container>
                {this.renderReviewModal()}
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}